import React, { Component, PropTypes } from 'react';
import { Table as SparkTable } from '@sabre/aven-spark';
import { Message } from 'sabre-spark-react';
import LabelsGridRow from './LabelsGridRow';
import { languagesWithCodes } from '../../../../../constants/labelsConstants';
import './LabelsGrid.scss';
import { connect } from 'react-redux';
import * as ActionTypes from '../../../../../constants/ActionTypes';
import BatchLabelsService from '../../../../../services/BatchLabelsService';
import store from '../../../../../store/Store';

class LabelsSparkTable extends SparkTable {
    _sizeColumns(unit, force) {
        unit = unit || '%';
        if (this._sizeColumnsRun && !force) {
            return;
        }
        let width = this.tableEl.offsetWidth;
        let thElements = [...this.tableEl.querySelectorAll('thead th')];

        thElements.slice(1).forEach(th => {
            if (unit === '%') th.style.width = (Math.round((th.offsetWidth / width) * 100000) / 100000) * 100 + '%';
            else th.style.width = th.offsetWidth + 'px';
        });
        this._sizeColumnsRun = true;
    }
}

class LabelsGrid extends Component {
    static propTypes = {
        selectedLanguages: PropTypes.array,
        labelsSearch: PropTypes.array,
        hasAccess: PropTypes.object.isRequired,
        inContextBeta: PropTypes.bool,
    };
    static defaultProps = {
        selectedLanguages: [],
        labelsSearch: [],
        inContextBeta: false
    };
    constructor(props) {
        super(props);
        this._container = null;
        this.handleSave = this.handleSave.bind(this);
        this.renderRows = this.renderRows.bind(this);
    }
    handleSave() {
        const { chainId, hotelId, level, currentValue } = this.props;
        return BatchLabelsService.save(chainId, hotelId, level, currentValue).finally(() => {
            store.dispatch({ type: ActionTypes.SAVED_LABELS_BATCH });
        });
    }
    renderRows() {
        return this.props.labelsSearch.map(entry => {
            return (
                <LabelsGridRow
                    hasAccess={this.props.hasAccess}
                    labelKey={entry.key}
                    labelsSearch={this.props.labelsSearch}
                    selectedLanguages={this.props.selectedLanguages}
                    key={entry.key}
                />
            );
        });
    }
    renderHead() {
        return this.props.selectedLanguages.map((languageCode, key) => {
            return (
                <th className="labels-grid__header-cell" key={key}>
                    {languagesWithCodes.find(language => language.code === languageCode).name} ({languageCode})
                </th>
            );
        });
    }
    render() {
        const { labelsSearch, inContextBeta } = this.props;
        if (labelsSearch.length > 0) {
            return (
                <section className={`spark-table spark-table--resizable spark-table--spreadsheet labels-grid col-xs-12 ${inContextBeta ? 'search-container' : ''}`}>
                    <header className="spark-table__header">
                        <h4 className="spark-table__title">
                            Labels{' '}
                            <button
                                className="spark-btn spark-btn--sm spark-pull-right"
                                disabled={!this.props.changed}
                                onClick={this.handleSave}
                            >
                                Save labels
                            </button>
                        </h4>
                    </header>
                    <div className="spark-table__scroll">
                        <table role="grid">
                            <thead>
                                <tr>
                                    <th>Label</th>
                                    {this.renderHead()}
                                </tr>
                            </thead>
                            <tbody>{this.renderRows()}</tbody>
                        </table>
                    </div>
                    <button
                        className="spark-btn spark-btn--sm spark-pull-right"
                        disabled={!this.props.changed}
                        onClick={this.handleSave}
                    >
                        Save labels
                    </button>
                </section>
            );
        }
        if (inContextBeta) {
            return <div className='search-container'><Message type="info" inline={true} title="No matches found" /></div>;
        }
        return <Message type="info" inline={true} title="No matches found" />;
    }
}

const mapStateToProps = state => {
    return {
        level: state.app.selected.level,
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        currentValue: state.app.search.labels.currentValue,
        changed: state.app.search.labels.changed
    };
};

export default connect(mapStateToProps)(LabelsGrid);



// WEBPACK FOOTER //
// ./src/components/pages/pages/search/labelsGrid/LabelsGrid.js